module.exports = __webpack_public_path__ + "static/img/装饰6.da5f71c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰6.svg
// module id = Y8N7
// module chunks = 2